/**
 * How "Open Gmail" opens the inbox: the Gmail app on iOS, a new browser tab
 * everywhere else.
 *
 * Android has no way in from a web page: browsers only start activities that
 * accept web links, and Gmail refused both a launcher intent and a VIEW intent
 * for mail.google.com (tried 2026-10-24 in Chrome and Samsung Internet – both
 * fell back to the browser). A new tab is also the better sign-in path: the
 * link tapped there signs in this same browser, while the Gmail app often
 * opens links in its own built-in browser.
 */
export type GmailOpen =
  | { kind: 'tab'; url: string }
  // iOS has no fallback built in: try the app scheme; if the page is still showing, offer the web inbox.
  | { kind: 'app-then-web'; appUrl: string; webUrl: string }

export function gmailWebUrl(email: string): string {
  return `https://mail.google.com/mail/u/?authuser=${encodeURIComponent(email)}`
}

export function planGmailOpen(userAgent: string, maxTouchPoints: number, email: string): GmailOpen {
  const webUrl = gmailWebUrl(email)
  // iPadOS reports itself as a Mac; touch points tell them apart.
  if (/iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)) {
    return { kind: 'app-then-web', appUrl: 'googlegmail://', webUrl }
  }
  return { kind: 'tab', url: webUrl }
}
